import { TResponseTransformer } from '__mocks__/types'

export const findNodeById = (id: string | null): TResponseTransformer => {
  return res => {
    const items = JSON.parse(res.body) || []
    res.body = !id ? [] : JSON.stringify(items[id])
    return res
  }
}

export const transformList = (transform: (items: any[]) => any): TResponseTransformer => {
  return res => {
    const items = JSON.parse(res.body) || []
    res.body = JSON.stringify(transform(items))
    return res
  }
}
